import React from 'react';
import './StartButton.css';

interface StartButtonProps {
  label: string;
  disabled?: boolean;
  onClick: () => void;
}

const StartButton: React.FC<StartButtonProps> = ({ label, disabled, onClick }) => {
  return (
    <button
      className="intro-hero-start"
      onClick={onClick}
      disabled={disabled}
      type="button"
    >
      {label}
    </button>
  );
};

export default StartButton;
